import { Controller } from "@hotwired/stimulus";
import type { FrameElement } from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["productField", "quantityField", "productQuantityFrame"];

  declare readonly hasProductFieldTarget: boolean;
  declare readonly productFieldTarget: HTMLInputElement;

  declare readonly hasQuantityFieldTarget: boolean;
  declare readonly quantityFieldTarget: HTMLInputElement;

  declare readonly hasProductQuantityFrameTarget: boolean;
  declare readonly productQuantityFrameTarget: FrameElement;

  productChanged() {
    if (this.hasProductQuantityFrameTarget && this.productFieldTarget?.value) {
      this.productQuantityFrameTarget.src = `/product_quantities_input/${this.productFieldTarget.value}?frame_id=${this.productQuantityFrameTarget.id}`;
    }
  }
}
